import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ParameterCreateUpdate from "./create-update";
import { Parameter } from "../../../models/types/parameter";
import parameterSvc from "../../../services/api/parameter";
import Loading from "../../../components/loading/loading";

export default function ParameterCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<Parameter | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            parameterSvc.getParameterById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ParameterCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}